import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types/woocommerce';
import { productsService } from '../services/products';

interface ProductCardProps {
  product: Product;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const discountPercentage = product.on_sale
    ? productsService.getDiscountPercentage(product.regular_price, product.sale_price)
    : 0;

  return (
    <Link to={`/products/${product.slug}`} className="group block">
      <div className="relative">
        {/* Image du produit */}
        <div className="relative overflow-hidden bg-gray-50 aspect-square">
          {product.images.length > 0 ? (
            <img
              src={product.images[0].src}
              alt={product.images[0].alt || product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full bg-gray-200 flex items-center justify-center">
              <span className="text-gray-400">Aucune image</span>
            </div>
          )}
          
          {/* Catégorie en overlay */}
          {product.categories.length > 0 && (
            <div className="absolute top-4 left-4">
              <span className="text-xs text-gray-600 font-light tracking-widest uppercase bg-white/80 backdrop-blur-sm px-2 py-1">
                {product.categories[0].name}
              </span>
            </div>
          )}
          
          {/* Badges si nécessaire */}
          {(product.on_sale && discountPercentage > 0) && (
            <div className="absolute top-4 right-4">
              <span className="bg-red-500 text-white px-2 py-1 text-xs font-light">
                -{discountPercentage}%
              </span>
            </div>
          )}
        </div>

        {/* Informations produit */}
        <div className="pt-4">
          {/* Titre */}
          <h3 className="text-gray-800 mb-2 font-light group-hover:text-gray-600 transition-colors line-clamp-2">
            {product.name}
          </h3>

          {/* Prix */}
          <div className="flex items-baseline justify-end gap-2">
            {product.on_sale ? (
              <>
                <span className="text-gray-500 line-through text-sm font-light">
                  {productsService.getFormattedPrice(product.regular_price)}
                </span>
                <span className="text-gray-800 font-light">
                  {productsService.getFormattedPrice(product.sale_price)}
                </span>
              </>
            ) : (
              <span className="text-gray-800 font-light">
                {productsService.getFormattedPrice(product.price)}
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
